// extracted by mini-css-extract-plugin
module.exports = {"content":"BaseMarquee_content_1PH93","marquee":"BaseMarquee_marquee_1ByD9"};